var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{staticStyle:{"padding":"1em","align-items":"center","z-index":"1"},attrs:{"toggleable":"","type":"dark","variant":"dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }